import countryList from "react-select-country-list";

export const useSupplierCountries = () => {
  const countries = countryList().getData();

  return { countries };
};
